export const BULK_UPLOAD_MODAL_TYPES = {
  BULK_UPLOAD_IMPORT: "BULK_UPLOAD_IMPORT",
  BULK_UPLOAD_ERROR: "BULK_UPLOAD_ERROR",
  BULK_UPLOAD_REVIEW: "BULK_UPLOAD_REVIEW",
};

export const SHEET_TYPES = {
  RATINGS: "RATINGS",
  BASIC_DETAILS: "BASIC_DETAILS",
};

export const OPERATION_TYPES = {
  CREATE: "CREATE",
  UPDATE: "UPDATE",
  SKIP: "SKIP",
};

export const OPERATION_TYPE_TAB_CONFIG = [
  {
    type: OPERATION_TYPES.CREATE,
    labelKey: "common:added",
    countKey: "createdCount",
  },
  {
    type: OPERATION_TYPES.UPDATE,
    labelKey: "common:edited",
    countKey: "updatedCount",
  },
  {
    type: OPERATION_TYPES.SKIP,
    labelKey: "common:skipped",
    countKey: "skippedCount",
  },
];

export const ERROR_CODES = {
  EMPTY_SHEET: "EMPTY_SHEET",
  NO_CHANGES_DETECTED: "NO_CHANGES_DETECTED",
  MISSING_REQUIRED_COLUMN: "MISSING_REQUIRED_COLUMN",
  DUPLICATE_COLUMNS: "DUPLICATE_COLUMNS",
  INCORRECT_FILE_FORMAT: "INCORRECT_FILE_FORMAT",
  INVALID_COLUMN: "INVALID_COLUMN",
};

export const PAGE_SIZE = 20;
export const PAGINATION_BUFFER = [0, 20];

export const ACCEPTED_FILE_FORMATS =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export const MODAL_WIDTH = {
  UPLOAD: "668px",
  REVIEW: "1440px",
  ERROR: "532px",
};

export const DATA_GRID_CELL_BACKGROUND_COLOR = {
  ERROR: "#FFEFEF",
  MODIFIED: "#FFF8E5",
};

// Maps backend column keys to locale keys for localized display.
// Keys not in this map fall back to the backend header.
export const COLUMN_LOCALE_MAP = {
  studentUid: "common:student_uid",
  studentName: "common:student_name",
  school: "common:school",
  academicYear: "common:academic_year",
  gradeLevel: "common:grade_level",
  gradingPeriod: "common:grading_period",
  course: "transcript:subject_course",
  courseCode: "transcript:course_id",
  level: "common:level",
};

// Maps raw backend header strings (with [Required]) to column keys.
// Used to reverse-lookup localized names for column-level validation errors.
export const BACKEND_HEADER_TO_KEY_MAP = {
  "Student UID [Required]": "studentUid",
  "Student name [Required]": "studentName",
  "School [Required]": "school",
  "Academic year [Required]": "academicYear",
  "Grade level [Required]": "gradeLevel",
  "Grading period [Required]": "gradingPeriod",
  "Subject/Course [Required]": "course",
  "Course ID": "courseCode",
  "Level (if applicable)": "level",
};

export const ROW_ERROR_CODES = {
  EMPTY_UID: "EMPTY_UID",
  UID_NOT_FOUND: "UID_NOT_FOUND",
  DUPLICATE_UID: "DUPLICATE_UID",
  DUPLICATE_ENTRY: "DUPLICATE_ENTRY",
  GRADE_MAPPING_NOT_FOUND: "GRADE_MAPPING_NOT_FOUND",
  GRADING_PERIOD_MAPPING_NOT_FOUND: "GRADING_PERIOD_MAPPING_NOT_FOUND",
  COURSE_NOT_FOUND: "COURSE_NOT_FOUND",
  LEVEL_NOT_FOUND: "LEVEL_NOT_FOUND",
};

const EMPTY_FIELD_ERROR_CODES = new Set([ROW_ERROR_CODES.EMPTY_UID]);
const DUPLICATE_ERROR_CODES = new Set([ROW_ERROR_CODES.DUPLICATE_ENTRY]);

export const getRowErrorCategory = errorCode => {
  if (EMPTY_FIELD_ERROR_CODES.has(errorCode)) return "empty";
  if (DUPLICATE_ERROR_CODES.has(errorCode)) return "duplicate";
  return "invalid";
};

export const ERROR_CELL_STYLE = {
  backgroundColor: DATA_GRID_CELL_BACKGROUND_COLOR.ERROR,
};

export const MODIFIED_CELL_STYLE = {
  backgroundColor: DATA_GRID_CELL_BACKGROUND_COLOR.MODIFIED,
};
